// extracted by mini-css-extract-plugin
module.exports = {"page-header":"AlertManagerHeader-module__page-header__3twh7","container":"AlertManagerHeader-module__container__1hjmm"};